export default __webpack_public_path__ + "media/images/about_us/roles/leonardo-morgatto-e95eca18c2f46b484353ec0abe8947a1.png";